document.addEventListener("turbolinks:load", () => {
  if ($('.steps-container img.icon[src*="progress-on"]') === 0) {
    return
  }

  if (window.innerWidth < 576) { // bootstrap sm breakpoint
    $('.steps-container').css("width", Math.max(100, $('.steps-container .form-step').length * 30) + "vw");
  }

  const offset = $('.steps-container img.icon[src*="progress-on"]')[0].getBoundingClientRect().x + 12
  const halfWidth = window.innerWidth / 2

  if (offset - halfWidth > 0) {
    $('.steps-container').parent('.steps-wrapper')[0].scrollLeft = offset - halfWidth;
  }
});
